module.exports = global["getCookie"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/exports-loader/index.js?getCookie!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./functions.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?getCookie!../node_modules/exports-loader?getCookie!../legacy/src/legacy/js/functions.js
// module id = 279
// module chunks = 0